/* unplugin-vue-components disabled */import { render } from "./WhiteListOn.vue?vue&type=template&id=46822ec2&scoped=true"
import script from "./WhiteListOn.vue?vue&type=script&lang=js"
export * from "./WhiteListOn.vue?vue&type=script&lang=js"

import "./WhiteListOn.vue?vue&type=style&index=0&id=46822ec2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46822ec2"]])

export default __exports__